import { render } from "./cotacaofretesbaseelk-list.vue?vue&type=template&id=01905bbb"
import script from "./cotacaofretesbaseelk-list.vue?vue&type=script&lang=js"
export * from "./cotacaofretesbaseelk-list.vue?vue&type=script&lang=js"

import "./cotacaofretesbaseelk-list.vue?vue&type=style&index=0&id=01905bbb&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__